import { render, staticRenderFns } from "./SalesPage2.vue?vue&type=template&id=2f652a94&"
import script from "./SalesPage2.vue?vue&type=script&lang=js&"
export * from "./SalesPage2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports